import { render } from "./PartnersList.vue?vue&type=template&id=0b8cc0ec&scoped=true"
import script from "./PartnersList.vue?vue&type=script&lang=js"
export * from "./PartnersList.vue?vue&type=script&lang=js"

import "./PartnersList.vue?vue&type=style&index=0&id=0b8cc0ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8cc0ec"]])

export default __exports__